import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, MailCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Recuperar() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [debugLink, setDebugLink] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setEnviado(true);
      if (data.enlace_debug) setDebugLink(data.enlace_debug);
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA] px-6" data-testid="recuperar-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <ShieldCheck className="text-[#FF5625]" size={28} />
          <span className="font-black text-xl tracking-tighter text-[#0E2A47]">AuditReady<span className="text-[#FF5625]">.</span></span>
        </div>

        {!enviado ? (
          <form onSubmit={submit} className="bg-white rounded-2xl border border-[#E2E8F0] shadow-sm p-8" data-testid="recuperar-form">
            <h2 className="text-2xl font-black tracking-tight text-[#0E2A47]">Recuperar contraseña</h2>
            <p className="text-sm text-[#0E2A47]/60 mt-1 mb-6">
              Escribe tu email y te enviaremos un enlace para elegir una nueva contraseña.
            </p>
            <Label className="text-xs font-bold uppercase tracking-wider text-[#0E2A47]/60">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="usuario@empresa.com" className="mt-1.5" data-testid="recuperar-email" />
            <Button type="submit" disabled={loading} data-testid="recuperar-submit"
              className="w-full mt-6 bg-[#FF5625] hover:bg-[#E0451A] text-white font-semibold">
              {loading ? <><Loader2 size={16} className="mr-2 animate-spin" />Enviando…</> : "Enviar enlace"}
            </Button>
            <div className="mt-6 text-sm text-center border-t border-[#E2E8F0] pt-5">
              <Link to="/login" className="text-[#FF5625] font-semibold" data-testid="recuperar-volver">Volver a iniciar sesión</Link>
            </div>
          </form>
        ) : (
          <div className="bg-white rounded-2xl border border-[#E2E8F0] shadow-sm p-8 text-center" data-testid="recuperar-enviado">
            <div className="mx-auto h-16 w-16 rounded-full bg-[#F7F8FA] border border-[#E2E8F0] flex items-center justify-center mb-5">
              <MailCheck className="text-[#10B981]" size={30} />
            </div>
            <h2 className="text-xl font-black tracking-tight text-[#0E2A47]">Revisa tu correo</h2>
            <p className="text-sm text-[#0E2A47]/70 mt-2">
              Si ese email tiene una cuenta, te hemos enviado un enlace para restablecer la contraseña. Caduca en 1 hora.
            </p>
            {debugLink && (
              <div className="mt-5 text-left bg-[#FFF7F3] border border-[#FFD9C9] rounded-lg p-3">
                <p className="text-xs font-bold text-[#B8451F] mb-1">Entorno de pruebas (email no enviado):</p>
                <a href={debugLink} className="text-xs text-[#FF5625] break-all underline" data-testid="recuperar-debug-link">{debugLink}</a>
              </div>
            )}
            <Link to="/login">
              <Button className="w-full mt-6 bg-[#0E2A47] hover:bg-[#163C65] text-white font-semibold">Ir a iniciar sesión</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
